module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.5ae23ad2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fontawesome-webfont.eot
// module id = ./src/fonts/fontawesome-webfont.eot
// module chunks = 0